import React, { useEffect, useMemo, useRef } from 'react';
import { models } from 'powerbi-client';
import { msalInstance, loginRequestPowerBI } from '../../msalConfig';
import { useSelector } from 'react-redux';
import { ROLE } from '../../utils/constants';

export const BI_DASHBOARD_TYPE = {
  MAIN: {
    key: 'main',
    groupId: process.env.REACT_APP_POWER_BI_GROUP_ID,
    reportId: process.env.REACT_APP_POWER_BI_REPORT_ID,
    pageId: null,
  },
  TALENT_OVERVIEW: {
    key: 'talent',
    groupId: process.env.REACT_APP_POWER_BI_GROUP_ID,
    reportId: process.env.REACT_APP_POWER_BI_REPORT_ID,
    pageId: process.env.REACT_APP_POWER_BI_TALENT_OVERVIEW,
  },
  SUCCESSION_PLANNING_OVERVIEW: {
    key: 'succession_plan',
    groupId: process.env.REACT_APP_POWER_BI_GROUP_ID,
    reportId: process.env.REACT_APP_POWER_BI_REPORT_ID,
    pageId: process.env.REACT_APP_POWER_BI_SUCCESSION_PLANNING_OVERVIEW,
  },
  TALENT_OVERVIEW_HR_COE: {
    key: 'hr_coe',
    groupId: process.env.REACT_APP_POWER_BI_GROUP_ID,
    reportId: process.env.REACT_APP_POWER_BI_REPORT_ID,
    pageId: process.env.REACT_APP_POWER_BI_TALENT_OVERVIEW_HR_COE,
  },
};

const PowerBIEmbed = () => {
  const reportRef = useRef();
  const roleActive = useSelector((state) => state.user.roleActive);
  const searchParams = new URLSearchParams(window.location.search);
  const pageName = searchParams.get('page');
  // const tenantId = 'fa6434db-4921-4ae3-8a0c-60977ad6c33c';

  const isAdminRole = useMemo(() => {
    return roleActive?.roleName ? [ROLE.ADMIN, ROLE.HR_COE].includes(roleActive?.roleName) : false;
  }, [roleActive]);

  const getPageDetail = useMemo(() => {
    let tempData = {};
    switch (pageName) {
      case BI_DASHBOARD_TYPE.MAIN.key:
        tempData = BI_DASHBOARD_TYPE.MAIN;
        break;
      case BI_DASHBOARD_TYPE.TALENT_OVERVIEW.key:
        tempData = isAdminRole ? BI_DASHBOARD_TYPE.TALENT_OVERVIEW_HR_COE : BI_DASHBOARD_TYPE.TALENT_OVERVIEW;
        break;
      case BI_DASHBOARD_TYPE.SUCCESSION_PLANNING_OVERVIEW.key:
        tempData = BI_DASHBOARD_TYPE.SUCCESSION_PLANNING_OVERVIEW;
        break;
      case BI_DASHBOARD_TYPE.TALENT_OVERVIEW_HR_COE.key:
        tempData = isAdminRole ? BI_DASHBOARD_TYPE.TALENT_OVERVIEW_HR_COE : BI_DASHBOARD_TYPE.MAIN;
        break;
      default:
        tempData = BI_DASHBOARD_TYPE.MAIN;
        break;
    }
    return tempData;
  }, [pageName, isAdminRole]);

  useEffect(() => {
    const embedUrl = getPageDetail?.pageId
      ? `https://app.powerbi.com/reportEmbed?reportId=${getPageDetail?.reportId}&groupId=${getPageDetail?.groupId}&pageName=${getPageDetail?.pageId}&experience=power-bi`
      : `https://app.powerbi.com/reportEmbed?reportId=${getPageDetail?.reportId}&groupId=${getPageDetail?.groupId}`;
    async function loadReport() {
      try {
        let account = msalInstance.getActiveAccount();
        const accounts = msalInstance.getAllAccounts();
        if (!account && accounts.length > 0) {
          account = accounts[0];
          msalInstance.setActiveAccount(account);
        }

        if (!account) {
          const loginResponse = await msalInstance.loginPopup(loginRequestPowerBI);
          account = loginResponse.account;
          msalInstance.setActiveAccount(account);
        }

        const tokenResponse = await msalInstance.acquireTokenSilent({
          ...loginRequestPowerBI,
          account,
        });

        // 👉 Reset Power BI before embedding
        window.powerbi.reset(reportRef.current);

        // 👉 Embed the report
        window.powerbi.embed(reportRef.current, {
          type: 'report',
          id: getPageDetail?.reportId,
          embedUrl: embedUrl,
          accessToken: tokenResponse.accessToken,
          tokenType: models.TokenType.Aad,
          permissions: models.Permissions.All,
          settings: {
            panes: {
              filters: { visible: false },
              pageNavigation: { visible: true },
            },
          },
        });
      } catch (error) {
        console.error('Error embedding Power BI:', error);
      }
    }

    loadReport();
  }, [getPageDetail, isAdminRole]);

  return <div ref={reportRef} style={{ height: '100vh', width: '100%' }} />;
};

export default PowerBIEmbed;
